import { useFormContext } from 'react-hook-form';

import { InviteFormType } from './useWorkspaceInviteForm';

interface UseInviteFieldReturn {
  invitees: string[];
  errors: Record<string, unknown>;
  addInvitee: (invitee: string) => void;
  removeInvitee: (invitee: string) => void;
  setInvitees: (invitees: string[]) => void;
  clearErrors: () => void;
}

const useInviteField = (): UseInviteFieldReturn => {
  const {
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<InviteFormType>();

  const invitees = watch('invitees') || [];

  const addInvitee = (invitee: string) => {
    const trimmedInvitee = invitee.trim();
    if (!trimmedInvitee || invitees.includes(trimmedInvitee)) return;

    setValue('invitees', [...invitees, trimmedInvitee], { shouldValidate: true });
  };

  const removeInvitee = (invitee: string) => {
    const newInvitees = invitees.filter((inv) => inv !== invitee);
    setValue('invitees', newInvitees, { shouldValidate: true });
    clearErrors('invitees');
  };

  const setInvitees = (newInvitees: string[]) => setValue('invitees', newInvitees, { shouldValidate: true });

  return {
    invitees,
    errors,
    addInvitee,
    removeInvitee,
    setInvitees,
    clearErrors: () => clearErrors('invitees'),
  };
};

export default useInviteField;
